import { getHost } from "./getHost"

export const isHostApp = () => {
  const currentHost = getHost()

  return currentHost === "app"
}
